module.exports = __webpack_public_path__ + "img/symbol_8.c0759aae.png";